import { getHeaders } from '@utility/helperFunction';
import { orderBy } from 'lodash';

export const LOYALTY_ACCOUNT_LOOKUP_REQUESTED = 'loyalty/LOYALTY_ACCOUNT_LOOKUP_REQUESTED';
export const LOYALTY_ACCOUNT_LOOKUP_SUCCESS = 'loyalty/LOYALTY_ACCOUNT_LOOKUP_SUCCESS';
export const LOYALTY_ACCOUNT_LOOKUP_FAILURE = 'loyalty/LOYALTY_ACCOUNT_LOOKUP_FAILURE';

export const LOYALTY_ACCOUNT_ASSIGN_REQUESTED = 'loyalty/LOYALTY_ACCOUNT_ASSIGN_REQUESTED';
export const LOYALTY_ACCOUNT_ASSIGN_SUCCESS = 'loyalty/LOYALTY_ACCOUNT_ASSIGN_SUCCESS';
export const LOYALTY_ACCOUNT_ASSIGN_FAILURE = 'loyalty/LOYALTY_ACCOUNT_ASSIGN_FAILURE';

export const LOYALTY_SIGNUP_REQUESTED = 'loyalty/LOYALTY_SIGNUP_REQUESTED';
export const LOYALTY_SIGNUP_SUCCESS = 'loyalty/LOYALTY_SIGNUP_SUCCESS';
export const LOYALTY_SIGNUP_FAILURE = 'loyalty/LOYALTY_SIGNUP_FAILURE';

export const ORDER_LOYALTY_SIGNUP_REQUESTED = 'loyalty/ORDER_LOYALTY_SIGNUP_REQUESTED';
export const ORDER_LOYALTY_SIGNUP_SUCCESS = 'loyalty/ORDER_LOYALTY_SIGNUP_SUCCESS';
export const ORDER_LOYALTY_SIGNUP_FAILURE = 'loyalty/ORDER_LOYALTY_SIGNUP_FAILURE';

export const ORDER_LOYALTY_SIGNIN_REQUESTED = 'loyalty/ORDER_LOYALTY_SIGNIN_REQUESTED';
export const ORDER_LOYALTY_SIGNIN_SUCCESS = 'loyalty/ORDER_LOYALTY_SIGNIN_SUCCESS';
export const ORDER_LOYALTY_SIGNIN_FAILURE = 'loyalty/ORDER_LOYALTY_SIGNIN_FAILURE';

export const ORDER_LOYALTY_GET_OFFERS_REQUESTED = 'loyalty/ORDER_LOYALTY_GET_OFFERS_REQUESTED';
export const ORDER_LOYALTY_GET_OFFERS_SUCCESS = 'loyalty/ORDER_LOYALTY_GET_OFFERS_SUCCESS';
export const ORDER_LOYALTY_GET_OFFERS_FAILURE = 'loyalty/ORDER_LOYALTY_GET_OFFERS_FAILURE';

export const PAY_LOYALTY_GET_OFFERS_REQUESTED = 'loyalty/PAY_LOYALTY_GET_OFFERS_REQUESTED';
export const PAY_LOYALTY_GET_OFFERS_SUCCESS = 'loyalty/PAY_LOYALTY_GET_OFFERS_SUCCESS';
export const PAY_LOYALTY_GET_OFFERS_FAILURE = 'loyalty/PAY_LOYALTY_GET_OFFERS_FAILURE';

export const ORDER_LOYALTY_APPLYOFFER_REQUESTED = 'loyalty/ORDER_LOYALTY_APPLYOFFER_REQUESTED';
export const ORDER_LOYALTY_APPLYOFFER_SUCCESS = 'loyalty/ORDER_LOYALTY_APPLYOFFER_SUCCESS';
export const ORDER_LOYALTY_APPLYOFFER_FAILURE= 'loyalty/ORDER_LOYALTY_APPLYOFFER_FAILURE';

export const ORDER_DELETE_LOYALTY_ACCOUNT_REQUESTED = 'loyalty/ORDER_DELETE_LOYALTY_ACCOUNT_REQUESTED';
export const ORDER_DELETE_LOYALTY_ACCOUNT_SUCCESS = 'loyalty/ORDER_DELETE_LOYALTY_ACCOUNT_SUCCESS';
export const ORDER_DELETE_LOYALTY_ACCOUNT_FAILURE = 'loyalty/ORDER_DELETE_LOYALTY_ACCOUNT_FAILURE';

export const LOYALTY_SIGNIN_REQUESTED = 'loyalty/LOYALTY_SIGNIN_REQUESTED';
export const LOYALTY_SIGNIN_SUCCESS = 'loyalty/LOYALTY_SIGNIN_SUCCESS';
export const LOYALTY_SIGNIN_FAILURE = 'loyalty/LOYALTY_SIGNIN_FAILURE';

export const LOYALTY_GET_OFFERS_REQUESTED = 'loyalty/LOYALTY_GET_OFFERS_REQUESTED';
export const LOYALTY_GET_OFFERS_SUCCESS = 'loyalty/LOYALTY_GET_OFFERS_SUCCESS';
export const LOYALTY_GET_OFFERS_FAILURE = 'loyalty/LOYALTY_GET_OFFERS_FAILURE';

export const LOYALTY_VALIDATE_OFFER_REQUESTED = 'loyalty/LOYALTY_VALIDATE_OFFER_REQUESTED';
export const LOYALTY_VALIDATE_OFFER_SUCCESS = 'loyalty/LOYALTY_VALIDATE_OFFER_SUCCESS';
export const LOYALTY_VALIDATE_OFFER_FAILURE = 'loyalty/LOYALTY_VALIDATE_OFFER_FAILURE';

export const LOYALTY_APPLY_OFFER_REQUESTED = 'loyalty/LOYALTY_APPLY_OFFER_REQUESTED';
export const LOYALTY_APPLY_OFFER_SUCCESS = 'loyalty/LOYALTY_APPLY_OFFER_SUCCESS';
export const LOYALTY_APPLY_OFFER_FAILURE = 'loyalty/LOYALTY_APPLY_OFFER_FAILURE';

export const LOYALTY_ACCOUNT_SIGNUP_REQUESTED = 'loyalty/LOYALTY_ACCOUNT_SIGNUP_REQUESTED';
export const LOYALTY_ACCOUNT_SIGNUP_SUCCESS = 'loyalty/LOYALTY_ACCOUNT_SIGNUP_SUCCESS';
export const LOYALTY_ACCOUNT_SIGNUP_FAILURE = 'loyalty/LOYALTY_ACCOUNT_SIGNUP_FAILURE';

export const DELETE_LOYALTY_ACCOUNT_REQUESTED = 'loyalty/DELETE_LOYALTY_ACCOUNT_REQUESTED';
export const DELETE_LOYALTY_ACCOUNT_SUCCESS = 'loyalty/DELETE_LOYALTY_ACCOUNT_SUCCESS';
export const DELETE_LOYALTY_ACCOUNT_FAILURE = 'loyalty/DELETE_LOYALTY_ACCOUNT_FAILURE';

export const CLEAR_LOYALTY_OFFERS = 'loyalty/CLEAR_LOYALTY_OFFERS';

export const CLEAR_SELECTED_OFFERS = 'loyalty/CLEAR_SELECTED_OFFERS';

export const LOYALTY_APPLYOFFER_REQUESTED = 'loyalty/LOYALTY_APPLYOFFER_REQUESTED';
export const LOYALTY_APPLYOFFER_SUCCESS = 'loyalty/LOYALTY_APPLYOFFER_SUCCESS';
export const LOYALTY_APPLYOFFER_FAILURE= 'loyalty/LOYALTY_APPLYOFFER_FAILURE';

export const LOYALTY_DELETEOFFER_REQUESTED = 'loyalty/LOYALTY_DELETEOFFER_REQUESTED';
export const LOYALTY_DELETEOFFER_SUCCESS = 'loyalty/LOYALTY_DELETEOFFER_SUCCESS';
export const LOYALTY_DELETEOFFER_FAILURE = 'loyalty/LOYALTY_DELETEOFFER_FAILURE';

export const LOYALTY_INFO_SUCCESS = 'loyalty/LOYALTY_INFO_SUCCESS';

export const LOYALTY_NEW_OFFERS_REQUESTED = 'loyalty/LOYALTY_NEW_OFFERS_REQUESTED';
export const LOYALTY_NEW_OFFERS_SUCCESS = 'loyalty/LOYALTY_NEW_OFFERS_SUCCESS';
export const LOYALTY_NEW_OFFERS_FAILURE = 'loyalty/LOYALTY_NEW_OFFERS_FAILURE';

export const SPLIT_LOYALTY_OFFERS_REQUESTED = 'loyalty/SPLIT_LOYALTY_OFFERS_REQUESTED';
export const SPLIT_LOYALTY_OFFERS_SUCCESS = 'loyalty/SPLIT_LOYALTY_OFFERS_SUCCESS';
export const SPLIT_LOYALTY_OFFERS_FAILURE = 'loyalty/SPLIT_LOYALTY_OFFERS_FAILURE';

export const SET_LOYALTY_TYPE = 'loyalty/SET_LOYALTY_TYPE';

export const LOYALTY_NEW_SIGNIN_REQUESTED = 'loyalty/LOYALTY_NEW_SIGNIN_REQUESTED';
export const LOYALTY_NEW_SIGNIN_SUCCESS = 'loyalty/LOYALTY_NEW_SIGNIN_SUCCESS';
export const LOYALTY_NEW_SIGNIN_FAILURE = 'loyalty/LOYALTY_NEW_SIGNIN_FAILURE';

export const LOYALTY_NEW_SIGNUP_REQUESTED = 'loyalty/LOYALTY_NEW_SIGNUP_REQUESTED';
export const LOYALTY_NEW_SIGNUP_SUCCESS = 'loyalty/LOYALTY_NEW_SIGNUP_SUCCESS';
export const LOYALTY_NEW_SIGNUP_FAILURE = 'loyalty/LOYALTY_NEW_SIGNUP_FAILURE';

export const MARK_REWARD_REDEEMED = 'loyalty/MARK_REWARD_REDEEMED';
export const CLEAR_REDEEMED_REWARDS = 'loyalty/CLEAR_REDEEMED_REWARDS';

export const SPLIT_LOYALTY_REWARDS_REQUESTED = 'loyalty/SPLIT_LOYALTY_REWARDS_REQUESTED';
export const SPLIT_LOYALTY_REWARDS_SUCCESS = 'loyalty/SPLIT_LOYALTY_REWARDS_SUCCESS';
export const SPLIT_LOYALTY_REWARDS_FAILURE = 'loyalty/SPLIT_LOYALTY_REWARDS_FAILURE';

export const SET_LOYALTY_ENTRY_SOURCE = 'loyalty/SET_LOYALTY_ENTRY_SOURCE';
export const CLEAR_LOYALTY_ENTRY_SOURCE = 'loyalty/CLEAR_LOYALTY_ENTRY_SOURCE';

const initialState = {
  loading: false,
  loaded: false,
  error: false,
  loyaltyOffers: null,
  groupedLoyaltyOffers: {},
  accountLookup: null,
  offerCouponGiftCard: {},
  SingedInloyaltyInfo: { phoneNumber: null, email: null, type: null },
  orderLoyaltyOffers: null,
  groupedLoyaltyOffer: {},
  offerCouponsGiftCard: {},
  loyaltyType: null,
  orderLoyaltyOffersData: null,
  loyaltyViewOffers: null,
  orderLoyaltyOfferData: null,
  groupedNewLoyaltyOffers: {},
  redeemedRewards: {},
  loyaltyEntrySource: null,
};

const allOffersSection = (action) => {
  const groupedLoyaltyOffers = {};
  const sortedOffers = orderBy(action.result?.loyalty?.offers, [(offer) => offer.groupSortOrder], ['asc']);
  (sortedOffers || []).forEach((offer) => {
    groupedLoyaltyOffers["OFFERS"] = {
      groupName: "OFFERS",
      offers: [...(groupedLoyaltyOffers["OFFERS"]?.offers || []), offer]
    };
  });
  return groupedLoyaltyOffers;
}

export default (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_SELECTED_OFFERS: {
      return {
        ...state,
        offerCouponGiftCard: {},
      };
    }
    case LOYALTY_ACCOUNT_LOOKUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        accountLookup: null,
      };
    }
    case LOYALTY_ACCOUNT_LOOKUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        accountLookup: action.result,
      };
    }
    case LOYALTY_ACCOUNT_LOOKUP_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_SIGNUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_SIGNUP_SUCCESS: {
      let groupedLoyaltyOffers = allOffersSection(action);
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        loyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffers,
      };
    }
    case LOYALTY_SIGNUP_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ORDER_LOYALTY_SIGNUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case ORDER_LOYALTY_SIGNUP_SUCCESS: {
      let groupedLoyaltyOffer = allOffersSection(action);
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOffersData: null,
        orderLoyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffer,
      };
    }
    case ORDER_LOYALTY_SIGNUP_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffersData:null,
      };
    }
    case LOYALTY_DELETEOFFER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_DELETEOFFER_SUCCESS: {
      const offerCouponGiftCard = {
        offer: action.result.paymentCheck.offer,
      };
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        offerCouponGiftCard,
      };
    }
    case LOYALTY_DELETEOFFER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ORDER_LOYALTY_SIGNIN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case ORDER_LOYALTY_SIGNIN_SUCCESS: {
      let groupedLoyaltyOffer = allOffersSection(action);
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOffersData: null,
        orderLoyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffer,
      };
    }
    case ORDER_LOYALTY_SIGNIN_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffersData: null,
      };
    }
    case LOYALTY_SIGNIN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_SIGNIN_SUCCESS: {
      let groupedLoyaltyOffers = allOffersSection(action);
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        loyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffers,
      };
    }
    case LOYALTY_SIGNIN_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_APPLYOFFER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_APPLYOFFER_SUCCESS: {
      const offerCouponGiftCard = {
        offer: action.result.paymentCheck.offer,
      };
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        offerCouponGiftCard,
      };
    }
    case LOYALTY_APPLYOFFER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ORDER_LOYALTY_APPLYOFFER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case ORDER_LOYALTY_APPLYOFFER_SUCCESS: {
      const offerCouponsGiftCard = {
        offer: action.result.paymentCheck.offer,
      };
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        offerCouponsGiftCard,
      };
    }
    case ORDER_LOYALTY_APPLYOFFER_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case LOYALTY_ACCOUNT_ASSIGN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_ACCOUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_ACCOUNT_ASSIGN_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_GET_OFFERS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_GET_OFFERS_SUCCESS: {
      const groupedLoyaltyOffers = {};
      const sortedOffers = orderBy(
        action.result?.offers,
        [offer => offer.groupSortOrder],
        ['asc']
      );
      (sortedOffers || []).forEach(offer => {
        groupedLoyaltyOffers[offer.groupName] = {
          groupName: offer.groupName,
          offers: [
            ...(groupedLoyaltyOffers[offer.groupName]?.offers || []),
            offer,
          ],
        };
      });
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        loyaltyOffers: action.result,
        groupedLoyaltyOffers,
      };
    }
    case LOYALTY_GET_OFFERS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ORDER_LOYALTY_GET_OFFERS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
   case ORDER_LOYALTY_GET_OFFERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOffersData: allOffersSection(action),
        loyaltyViewOffers: action.result,
        orderLoyaltyOffers: null,
        groupedLoyaltyOffers: null,
      };
    }

    case ORDER_LOYALTY_GET_OFFERS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffers: null,
        groupedLoyaltyOffers: null,
      };
    }

    case PAY_LOYALTY_GET_OFFERS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false,
      };
    }
    case PAY_LOYALTY_GET_OFFERS_SUCCESS: {

      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOfferData: allOffersSection(action),
        orderLoyaltyOffers: null,
        groupedNewLoyaltyOffers: null,
      };
    }

    case PAY_LOYALTY_GET_OFFERS_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffers: null,
        groupedNewLoyaltyOffers: null,
      };
    }
    case LOYALTY_VALIDATE_OFFER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_VALIDATE_OFFER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_VALIDATE_OFFER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_APPLY_OFFER_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_APPLY_OFFER_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_APPLY_OFFER_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_ACCOUNT_SIGNUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case LOYALTY_ACCOUNT_SIGNUP_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case LOYALTY_ACCOUNT_SIGNUP_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case DELETE_LOYALTY_ACCOUNT_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case DELETE_LOYALTY_ACCOUNT_SUCCESS: {
      window.sessionStorage.removeItem('loyaltyData');
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
        offerCouponGiftCard: {},
      };
    }
    case DELETE_LOYALTY_ACCOUNT_FAILURE: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case ORDER_DELETE_LOYALTY_ACCOUNT_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case ORDER_DELETE_LOYALTY_ACCOUNT_SUCCESS: {
      window.sessionStorage.removeItem('loyaltyData');
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        offerCouponsGiftCard: {},
      };
    }
    case ORDER_DELETE_LOYALTY_ACCOUNT_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
      };
    }
    case CLEAR_LOYALTY_OFFERS:
      return {
        ...state,
        groupedLoyaltyOffers: {},
        loyaltyOffers: null,
        accountLookup: null,
      };
      case LOYALTY_INFO_SUCCESS: {
        return {
          ...state,
          SingedInloyaltyInfo: action.payload
        }
      }
      case LOYALTY_NEW_OFFERS_REQUESTED: {
        return {
          ...state,
          loading: true,
          loaded: false,
        };
      }
      case LOYALTY_NEW_OFFERS_SUCCESS: {
        return {
          ...state,
          loading: false,
          error: false,
          loaded: true,
          loyaltyOffers: action?.result?.loyalty,
        };

      }
      case LOYALTY_NEW_OFFERS_FAILURE: {
        return {
          ...state,
          loading: false,
          error: false,
          loaded: true,
        };
    }
    case SET_LOYALTY_TYPE: {
      return {
        ...state,
        loyaltyType: action.payload
      }
    }
    case SPLIT_LOYALTY_OFFERS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SPLIT_LOYALTY_OFFERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case SPLIT_LOYALTY_OFFERS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
        loaded: false,
      };
    }
    case LOYALTY_NEW_SIGNUP_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case LOYALTY_NEW_SIGNUP_SUCCESS: {
      let groupedLoyaltyOffer = allOffersSection(action);
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOffersData: null,
        orderLoyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffer,
      };
    }
    case LOYALTY_NEW_SIGNUP_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffersData:null,
      };
    }
     case LOYALTY_NEW_SIGNIN_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
        error: false
      };
    }
    case LOYALTY_NEW_SIGNIN_SUCCESS: {
      let groupedLoyaltyOffer = allOffersSection(action);
      return {
        ...state,
        loading: false,
        loaded: true,
        error: false,
        orderLoyaltyOffersData: null,
        orderLoyaltyOffers: action.result.loyalty,
        groupedLoyaltyOffer,
      };
    }
    case LOYALTY_NEW_SIGNIN_FAILURE: {
      return {
        ...state,
        loading: false,
        loaded: false,
        error: true,
        orderLoyaltyOffersData: null,
      };
    }
    case MARK_REWARD_REDEEMED: {
      const { splitId, offerId } = action.payload;
      return {
        ...state,
        redeemedRewards: {
          ...state.redeemedRewards,
          [splitId]: [...(state.redeemedRewards[splitId] || []), offerId],
        },
      };
    }
    case CLEAR_REDEEMED_REWARDS: {
      return {
        ...state,
        redeemedRewards: {},
      };
    }
    case SPLIT_LOYALTY_REWARDS_REQUESTED: {
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    }
    case SPLIT_LOYALTY_REWARDS_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: false,
        loaded: true,
      };
    }
    case SPLIT_LOYALTY_REWARDS_FAILURE: {
      return {
        ...state,
        loading: false,
        error: true,
        loaded: false,
      };
    }
    case SET_LOYALTY_ENTRY_SOURCE: {
      return {
        ...state,
        loyaltyEntrySource: action.payload,
      };
    }
    case CLEAR_LOYALTY_ENTRY_SOURCE: {
      return {
        ...state,
        loyaltyEntrySource: null,
      };
    }
    default:
      return state;
  }
};

export const loyaltyAccountLookup = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_ACCOUNT_LOOKUP_REQUESTED, LOYALTY_ACCOUNT_LOOKUP_SUCCESS, LOYALTY_ACCOUNT_LOOKUP_FAILURE],
    promise: (client) => client.post('loyaltyAccountLookup', {
      data,
      headers
    }),
  };
};

export const loyaltyAccountAssign = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_ACCOUNT_ASSIGN_REQUESTED, LOYALTY_ACCOUNT_ASSIGN_SUCCESS, LOYALTY_ACCOUNT_ASSIGN_FAILURE],
    promise: (client) => client.post('loyaltyAccountAssign', {
      data,
      headers
    }),
  };
};

export const loyaltySignUp = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_SIGNUP_REQUESTED, LOYALTY_SIGNUP_SUCCESS, LOYALTY_SIGNUP_FAILURE],
    promise: (client) => client.post('loyaltySignUp', {
      data,
      headers
    }),
  };
};

export const loyaltySignIn = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_SIGNIN_REQUESTED, LOYALTY_SIGNIN_SUCCESS, LOYALTY_SIGNIN_FAILURE],
    promise: (client) => client.post('loyaltySignIn', {
      data,
      headers
    }),
  };
};

export const loyaltyGetOffers = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_GET_OFFERS_REQUESTED, LOYALTY_GET_OFFERS_SUCCESS, LOYALTY_GET_OFFERS_FAILURE],
    promise: (client) => client.post('loyaltyGetOffers', {
      data,
      headers
    }),
  };
};

export const loyaltyValidateOffer = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_VALIDATE_OFFER_REQUESTED, LOYALTY_VALIDATE_OFFER_SUCCESS, LOYALTY_VALIDATE_OFFER_FAILURE],
    promise: (client) => client.post('loyaltyValidateOffer', {
      data,
      headers
    }),
  };
};

export const loyaltyApplyOffer = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_APPLY_OFFER_REQUESTED, LOYALTY_APPLY_OFFER_SUCCESS, LOYALTY_APPLY_OFFER_FAILURE],
    promise: (client) => client.post('loyaltyApplyOffer', {
      data,
      headers
    }),
  };
};

export const loyaltyAccountSignUp = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_ACCOUNT_SIGNUP_REQUESTED, LOYALTY_ACCOUNT_SIGNUP_SUCCESS, LOYALTY_ACCOUNT_SIGNUP_FAILURE],
    promise: (client) => client.post('loyaltyAccountSignUp', {
      data,
      headers
    }),
  };
};

export const deleteLoyaltyAccount = (data) => {
  const headers = getHeaders();
  return {
    types: [DELETE_LOYALTY_ACCOUNT_REQUESTED, DELETE_LOYALTY_ACCOUNT_SUCCESS, DELETE_LOYALTY_ACCOUNT_FAILURE],
    promise: (client) => client.post('deleteLoyaltyAccount', {
      data,
      headers
    }),
  };
};

export const clearLoyaltyOffers = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_LOYALTY_OFFERS
    });
  };
};

export const applyLoyaltyOffer = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_APPLYOFFER_REQUESTED, LOYALTY_APPLYOFFER_SUCCESS, LOYALTY_APPLYOFFER_FAILURE],
    promise: (client) => client.post('applyLoyaltyOffer', {
      data,
      headers
    }),
  };
};

export const handleDeleteOffer = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_DELETEOFFER_REQUESTED, LOYALTY_DELETEOFFER_SUCCESS, LOYALTY_DELETEOFFER_FAILURE],
    promise: (client) => client.post('handleDeleteOffer', {
      data,
      headers
    }),
  };
};

export const clearSelectedOffers = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_SELECTED_OFFERS
    });
  };
};

export const handleLoyaltyInfo = (data) => {
  return (dispatch) => {
    dispatch({
      type: LOYALTY_INFO_SUCCESS,
      payload: data
    })
  }
}

export const loyaltyNewBalance = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_NEW_OFFERS_REQUESTED, LOYALTY_NEW_OFFERS_SUCCESS, LOYALTY_NEW_OFFERS_FAILURE],
    promise: (client) => client.post('loyaltyNewBalance', {
      data,
      headers
    }),
  };
};

export const orderLoyaltySignUp = (data) => {
  const headers = getHeaders();
  return {
    types: [ORDER_LOYALTY_SIGNUP_REQUESTED, ORDER_LOYALTY_SIGNUP_SUCCESS, ORDER_LOYALTY_SIGNUP_FAILURE],
    promise: (client) => client.post('orderLoyaltySignUp', {
      data,
      headers
    }),
  };
};

export const orderLoyaltySignIn = (data) => {
  const headers = getHeaders();
  return {
    types: [ORDER_LOYALTY_SIGNIN_REQUESTED, ORDER_LOYALTY_SIGNIN_SUCCESS, ORDER_LOYALTY_SIGNIN_FAILURE],
    promise: (client) => client.post('orderLoyaltySignIn', {
      data,
      headers
    }),
  };
};

export const orderLoyaltyGetOffers = (data) => {
  const headers = getHeaders();
  return {
    types: [ORDER_LOYALTY_GET_OFFERS_REQUESTED, ORDER_LOYALTY_GET_OFFERS_SUCCESS, ORDER_LOYALTY_GET_OFFERS_FAILURE],
    promise: (client) => client.post('orderLoyaltyGetOffers', {
      data,
      headers
    }),
  };
};

export const orderApplyLoyaltyOffer = (data) => {
  const headers = getHeaders();
  return {
    types: [ORDER_LOYALTY_APPLYOFFER_REQUESTED, ORDER_LOYALTY_APPLYOFFER_SUCCESS, ORDER_LOYALTY_APPLYOFFER_FAILURE],
    promise: (client) => client.post('orderApplyLoyaltyOffer', {
      data,
      headers
    }),
  };
};

export const orderDeleteLoyaltyAccount = (data) => {
  const headers = getHeaders();
  return {
    types: [ORDER_DELETE_LOYALTY_ACCOUNT_REQUESTED, ORDER_DELETE_LOYALTY_ACCOUNT_SUCCESS, ORDER_DELETE_LOYALTY_ACCOUNT_FAILURE],
    promise: (client) => client.post('orderDeleteLoyaltyAccount', {
      data,
      headers
    }),
  };
};


export const setOrderLoyaltyType = (data) => {
  return (dispatch) => {
    dispatch(({
      type: SET_LOYALTY_TYPE,
      payload: data,
    }))
  }
}

export const paymentLoyaltyGetOffers = (data) => {
  const headers = getHeaders();
  return {
    types: [PAY_LOYALTY_GET_OFFERS_REQUESTED, PAY_LOYALTY_GET_OFFERS_SUCCESS, PAY_LOYALTY_GET_OFFERS_FAILURE],
    promise: (client) => client.post('paymentLoyaltyGetOffers', {
      data,
      headers
    }),
  };
}

export const loyaltySplitOffers = (data) => {
  const headers = getHeaders();
  return {
    types: [SPLIT_LOYALTY_OFFERS_REQUESTED, SPLIT_LOYALTY_OFFERS_SUCCESS, SPLIT_LOYALTY_OFFERS_FAILURE],
    promise: (client) => client.post('splitLoyaltyOffer', {
      data,
      headers
    }),
  };
};

export const loyaltyNewAccountSignUp = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_NEW_SIGNUP_REQUESTED, LOYALTY_NEW_SIGNUP_SUCCESS, LOYALTY_NEW_SIGNUP_FAILURE],
    promise: (client) => client.post('loyaltyNewAccountSignUp', {
      data,
      headers
    }),
  };
};

export const loyaltyNewAccountSignIn = (data) => {
  const headers = getHeaders();
  return {
    types: [LOYALTY_NEW_SIGNIN_REQUESTED, LOYALTY_NEW_SIGNIN_SUCCESS, LOYALTY_NEW_SIGNIN_FAILURE],
    promise: (client) => client.post('loyaltyNewAccountSignIn', {
      data,
      headers
    }),
  };
};

export const markRewardRedeemed = ({ splitId, offerId }) => dispatch => {
  dispatch({ type: MARK_REWARD_REDEEMED, payload: { splitId, offerId } });
};

export const clearRedeemedRewards = () => dispatch => {
  dispatch({ type: CLEAR_REDEEMED_REWARDS });
};

export const loyaltySplitRewards = (data) => {
  const headers = getHeaders();
  return {
    types: [SPLIT_LOYALTY_REWARDS_REQUESTED, SPLIT_LOYALTY_REWARDS_SUCCESS, SPLIT_LOYALTY_REWARDS_FAILURE],
    promise: (client) => client.post('splitLoyaltyRewards', {
      data,
      headers
    }),
  };
};

export const setLoyaltyEntrySource = (source) => ({
  type: SET_LOYALTY_ENTRY_SOURCE,
  payload: source,
});

export const clearLoyaltyEntrySource = () => ({
  type: CLEAR_LOYALTY_ENTRY_SOURCE,
});
